import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AppContainer from "../Appcontainer";
import store from "../../store";
import { Provider } from "react-redux";
import Login from "../../views/pages/Authentication/Login";
import Error404 from "../../views/pages/Error/Error404";
import Error500 from "../../views/pages/Error/Error500";
import ForgotPassword from "../../views/pages/Authentication/ForgotPassword";
import { Navigate } from "react-router-dom/dist";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/modal.css";
import Error403 from "../../views/pages/Error/Error403";
import { RoleProvider } from "../../context/RoleContext";
import { useAuth } from "../../context/AuthContext";
import SessionChecker from "../../components/SessionChecker";
import api from "../../api/axios";
import LoginWithLink from "../../views/pages/Authentication/LoginWithLink";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";
import PaymentConfirmation from "../../views/pages/Payment/PaymentConfirmation";
import SubscriptionModal from "../../components/modelpopup/SubscriptionModal";
import { decrypt } from "../../utils/crypto";
import { fetchCompanySubscription } from "../../services/SubscriptionService";
import { companyID } from "../../auth";
import { set } from "date-fns";
import PlanConfigurationModal from "../../components/PlanConfigurationModal";
import SubscriptionExpire from "../../views/pages/Pages/SubscriptionExpire";
import LinkClickLogger from "./LinkClickLogger";
import DocumentAcceptance from "../../views/pages/HR/Recruitment/DocumentAcceptance";
import DocumentAccepted from "../../views/pages/HR/Recruitment/DocumentAccepted";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRouter = () => {
  const [userRole, setUserRole] = useState(null);
  const { isAuthenticated } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const roleId = localStorage.getItem("employee_role");
  const isSubscriptionExpired = JSON.parse(
    localStorage.getItem("isSubscriptionExpired")
  );
  const isSubscriptionExpiredSoon =
    localStorage.getItem("isSubscriptionExpiredSoon") != "undefined" &&
    localStorage.getItem("isSubscriptionExpiredSoon") != null
      ? JSON.parse(localStorage.getItem("isSubscriptionExpiredSoon"))
      : false;
  const expiredSubscriptionPlan =
    localStorage.getItem("expired_subscription") || null;
  const [selectedSubcriptionData, setSelectedSubscriptionData] = useState({});
  const [plans, setPlans] = useState([]);

  const fetchCompanySubscriptionDetails = async (subscription_id) => {
    const company_id = companyID();
    const subscription = await fetchCompanySubscription(
      company_id,
      subscription_id
    );
    if (subscription && subscription.length > 0) {
      setSelectedSubscriptionData(subscription[0]);
    }
  };
  const fetchPlans = async () => {
    try {
      const response = await api.get("plans");
      if (response.status === 200) {
        setPlans(response.data.data ?? []);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (isSubscriptionExpiredSoon && expiredSubscriptionPlan) {
      setShowModal(true);
      const subscription_id = decrypt(expiredSubscriptionPlan);
      fetchCompanySubscriptionDetails(subscription_id);
      fetchPlans();
    }

    if (roleId) {
      api
        .get(`employeeRole/${roleId}`)
        .then((res) => setUserRole(res?.data[0].role_name))
        .catch((err) => console.error("Employee role error : ", err));
    }
  }, [isAuthenticated]);

  const handleCloseModal = () => {
    if (isSubscriptionExpired) {
      setShowModal(true);
    } else {
      setShowModal(false);
      setSelectedSubscriptionData({});
    }
  };

  console.log("isSubscriptionExpiredSoon2", isSubscriptionExpiredSoon);

  return (
    <RoleProvider role={userRole}>
      <div>
        <Provider store={store}>
          <BrowserRouter basename="/">
            <LinkClickLogger />
            <ScrollToTop />
            <SessionChecker />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <Routes>
              {/* Public Document Acceptance Routes */}
              <Route 
                path="/candidates/document-acceptance" 
                element={<DocumentAcceptance />} 
              />
              <Route 
                path="/document-accepted" 
                element={<DocumentAccepted />} 
              />

              <Route path="/" element={<Login />} />
              
              <Route
                path="/:company_name/*"
                element={
                  !isAuthenticated ? (
                    <Login />
                  ) : (
                    <>
                      <Header />
                      <Sidebar />
                      <PrivateRoute element={AppContainer} />
                    </>
                  )
                }
              />
              <Route path="/error-404" element={<Error404 />} />
              <Route path="/error-403" element={<Error403 />} />
              <Route path="/error-500" element={<Error500 />} />
              {!isAuthenticated && (
                <Route path="/forgot-password" element={<ForgotPassword />} />
              )}
              <Route
                path="/payment-confirmation"
                element={<PaymentConfirmation />}
              />
              <Route path="/login/token" element={<LoginWithLink />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
        </Provider>
      </div>
    </RoleProvider>
  );
};

export default AppRouter;
